import { render, staticRenderFns } from "./SingleItem.vue?vue&type=template&id=78dda07c"
import script from "./SingleItem.vue?vue&type=script&lang=js"
export * from "./SingleItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports